var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#020C41;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.4,30.4c1.1,0.5,2.7,0.7,3.7,0.4c1.6-0.5,2.6-2,2.2-3.4c-0.4-1.4-2-1.7-3.6-1.7c-1.7,0-3.2-0.3-3.6-1.7 s0.6-2.9,2.2-3.4c1.1-0.3,2.2-0.1,2.9,0.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.8,
    y1: 19.3,
    x2: 25.2,
    y2: 20.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28,
    y1: 30.8,
    x2: 28.4,
    y2: 32.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.4,29.9c5.1,3.1,5.1,14-2.7,15.4v4c0,1-0.8,1.8-1.8,1.8H15.6c-1,0-1.8-0.8-1.8-1.8v-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,13.9l-1-3.7c-0.2-1-1.2-1.5-2.2-1.3l-31.1,8c-1,0.2-1.5,1.2-1.3,2.2l1,3.7c-7.6,3.4-4.4,16.1,4,15.4 l1,3.7c0.2,1,1.2,1.5,2.2,1.3l31.1-8c1-0.2,1.5-1.2,1.3-2.2l-1-3.7C53.5,25.9,50.3,13.3,42,13.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZed);
export default __webpack_public_path__ + "static/media/zed.a7877d91564f1f0ff9e77739c47bd962.svg";
export { ForwardRef as ReactComponent };